import { Component, OnInit, Input } from '@angular/core';
import { Instructor } from '@modules/instructor/models/instructor';
import { Multimedia } from '@modules/shared/models/multimedia';

@Component({
  selector: 'app-instructor-preview-card',
  templateUrl: './instructor-preview-card.component.html',
  styleUrls: ['./instructor-preview-card.component.scss']
})
export class InstructorPreviewCardComponent implements OnInit {
  @Input()
  instructor: Instructor;
  baseRoute: string = '/instruktor/profil';

  constructor() { }

  ngOnInit(): void {
  }

  public getInstructorDefaultMedia(mediaList: Multimedia[]): string {
    const profilePicture = mediaList.find((x) => x.default && x.category === 'profile');
    return  profilePicture ? profilePicture.url : 'assets/images/user.png';
  }

}
